module.exports = __webpack_public_path__ + "img/Paso2Check.40263363.svg";